'use client';

import React from 'react';
import { ThemeProvider } from '@pickatale/ui-kit';
import { ApiContextProvider } from '@/context/Api';
import { AuthenticationContextProvider } from '@/context/Authentication';
import { DataContextProvider } from '@/context/Data';
import { UiContextProvider } from '@/context/Ui';
import { TransifexProvider } from '@/context/Transifex';

export function Providers({ children }: React.PropsWithChildren) {
  return (
    <TransifexProvider>
      <ApiContextProvider>
        <AuthenticationContextProvider>
          <DataContextProvider>
            <ThemeProvider>
              <UiContextProvider>
                <TransifexProvider>{children}</TransifexProvider>
              </UiContextProvider>
            </ThemeProvider>
          </DataContextProvider>
        </AuthenticationContextProvider>
      </ApiContextProvider>
    </TransifexProvider>
  );
}
